// import type { RouteRecordRaw } from 'vue-router';
//
// export const gradesRoutes: RouteRecordRaw = {
//     path: 'grades',
//     components: {
//         default: () => import('@/layouts/modules/grades/GradesLayout.vue'),
//         sidebar: () => import('@/layouts/modules/grades/GradesAside.vue')
//     },
//     children: [
//         // School Grades Routes
//         {
//             path: 'school',
//             children: [
//                 {
//                     path: 'comment-categories',
//                     name: 'CommentCategories',
//                     component: () => import('@/views/modules/grades/CommentCategoriesView.vue'),
//                 },
//                 {
//                     path: 'comment-type',
//                     name: 'CommentType',
//                     component: () => import('@/views/modules/grades/SchoolCommentTypesView.vue'),
//                 }
//             ]
//         }
//     ]
// };

import type { RouteRecordRaw } from 'vue-router';

export const gradesRoutes: RouteRecordRaw = {
    path: 'grades',
    components: {
        default: () => import('@/layouts/modules/grades/GradesLayout.vue'),
        sidebar: () => import('@/layouts/modules/grades/GradesAside.vue')
    },
    children: [
        // School Grades Routes
        {
            path: 'school',
            children: [
                {
                    path: 'comment-type',
                    name: 'CommentType',
                    component: () => import('@/views/modules/grades/SchoolCommentTypesView.vue'),
                },
                {
                    path: 'assessment-types',
                    name: 'SchoolAssessmentTypes',
                    component: () => import('@/views/modules/grades/SchoolAssessmentTypesView.vue'),
                },
                {
                    path: 'marking-systems',
                    name: 'MarkingSystems',
                    component: () => import('@/views/modules/grades/MarkingSystemView.vue'),
                    children: [
                        {
                            path: 'create',
                            name: 'CreateMarkingSystem',
                            component: () => import('@/components/modules/grades/MarkingSystemCreateModal.vue'),
                        },
                        {
                            path: ':systemId/update',
                            name: 'UpdateMarkingSystem',
                            component: () => import('@/components/modules/grades/MarkingSystemEditModal.vue'),
                        },
                        {
                            path: ':systemId/options',
                            name: 'MarkingSystemOptions',
                            component: () => import('@/components/modules/grades/MarkingSystemOptionsDrawer.vue'),
                        }
                    ]
                }
            ]
        },
        // System-wide Assessment Types
        {
            path: 'comment-categories',
            name: 'CommentCategories',
            component: () => import('@/views/modules/grades/CommentCategoriesView.vue'),
        },
        {
            path: 'assessment-types',
            name: 'AssessmentTypes',
            component: () => import('@/views/modules/grades/AssessmentTypesView.vue'),
        }
    ]
};